import template from './sales-by-category.html';
import controller from './sales-by-category.controller';
import './sales-by-category.scss';

let SalesByCategoryComponent = {
  bindings: {
    itemsObservable: '<',
    dates: '<'
  },
  template,
  controller
};

export default SalesByCategoryComponent;



// WEBPACK FOOTER //
// ./src/app/pages/sales-by-category/sales-by-category.component.js